import React, { ChangeEvent, useEffect, useState } from 'react';
import styles from './Installningar.module.css';
import classNames from 'classnames';

import { Settings } from '@mui/icons-material';
import { useKartstodContext } from '../contexts/KartstodContext';
import ModalInfotext from '../ModalInfotext';
import { Stack, TextField } from '@mui/material';
import { usePremiumContext } from '../contexts/PremiumContext';

const Installningar = () => {
  const {
    isInstallningarAktiv,
    setIsInstallningarAktiv,
    buffertRadie,
    setBuffertRadie,
  } = usePremiumContext();
  const {
    isInstallningarOpen,
    setIsRitverktygOpen,
    setIsInstallningarOpen,
    setIsSokKoordinaterOpen,
  } = useKartstodContext();
  const [visaHjalpRuta, setVisaHjalpRuta] = useState(false);

  useEffect(() => {
    if (buffertRadie === '0' || buffertRadie === '') {
      setIsInstallningarAktiv(false);
    } else {
      setIsInstallningarAktiv(true);
    }
  }, [buffertRadie]);

  const togglaInstallningar = () => {
    setIsInstallningarOpen(!isInstallningarOpen);
    setIsRitverktygOpen(false);
    setIsSokKoordinaterOpen(false);
    setVisaHjalpRuta(false);
  };

  const handleBuffertRadie = (
    event: ChangeEvent<HTMLTextAreaElement | HTMLInputElement>
  ) => {
    if (event.target.value === '') {
      setBuffertRadie('0');
    } else {
      setBuffertRadie(event.target.value);
    }
  };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
    if (event.key === 'Enter') {
      setIsInstallningarOpen(false);
    }
  };

  const hovraRitverktyg = () => {
    if (isInstallningarOpen || isInstallningarAktiv) {
      setVisaHjalpRuta(false);
    } else {
      setVisaHjalpRuta(true);
    }
  };

  const doljHjalpRuta = () => {
    setVisaHjalpRuta(false);
  };

  return (
    <>
      {visaHjalpRuta ? (
        <ModalInfotext
          meddelande={'Inställningar till ritverktyg'}
          style={{ top: '116px', width: '138px' }}
        />
      ) : null}
      <div
        className={classNames(
          styles.settingsContainer,
          isInstallningarOpen
            ? styles.settingsContainerActive
            : styles.shrinkIcon
        )}
      >
        <div
          className={classNames(
            styles.settingsTool,
            isInstallningarAktiv ? styles.activeTool : ''
          )}
          onMouseEnter={() => hovraRitverktyg()}
          onMouseLeave={() => doljHjalpRuta()}
          onClick={togglaInstallningar}
        >
          <Settings />
        </div>
        <div className={styles.settingsContentContainer}>
          <Stack>
            <div className={styles.settingsContentHeader}>Inställningar</div>
            <TextField
              id="outlined-number"
              size="small"
              className={styles.buffertRadie}
              label="Buffer i meter"
              type="number"
              InputLabelProps={{
                shrink: true,
              }}
              inputProps={{
                min: 0,
                max: 100,
              }}
              variant="outlined"
              value={buffertRadie}
              onChange={(event) => handleBuffertRadie(event)}
              onKeyDown={(event) => handleKeyDown(event)}
            />
          </Stack>
        </div>
      </div>
    </>
  );
};

export default Installningar;
